// =========================== Motion ===========================
const genRtlStyle = token => {
  const {
    componentCls
  } = token;
  return {
    [`${componentCls}-rtl`]: {
      direction: 'rtl'
    }
  };
};
export default genRtlStyle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/upload/style/rtl.js
// module id = 2949
// module chunks = 0